import { Outlet, useLocation } from 'react-router-dom'

import { BaseHeader } from '../components/BaseHeader'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import { WithAuth } from '../containers/hoc/WithAuth'
import type { EnvironmentType } from '../context/AppContext'
import { AppProvider } from '../context/AppContext'
import type { IAvailableApps } from '../utils/availableApps'

import { CustomToastContainer } from 'brokertslib/src/components/CustomToastContainer'
import { useLayoutEffect } from 'react'

export interface BaseLayoutProps {
  app: IAvailableApps['appId'] | null
  environment?: EnvironmentType
}

const BaseLayoutComponent = ({ app }: BaseLayoutProps) => {
  const location = useLocation()
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <AppProvider app={app}>

      {app && <Header />}
      {!app && <BaseHeader />}

      <Outlet />

      <CustomToastContainer />

      <Footer />
    </AppProvider>
  )
}

export const BaseLayout = WithAuth(BaseLayoutComponent)
